module.exports = __webpack_public_path__ + "img/p_sz_3.fe874e76.svg";